<template>
  <v-hover>
    <v-card pa-0 :disabled="$store.getters.isLoading" width="100%">
      <div>
        <slot name="body" />
        <slot name="expantion" />
      </div>
    </v-card>
  </v-hover>
</template>

<script>
export default {
  name: "CardPaymentComponents",
  props: {
    isReady: {
      type: Boolean,
      default: true,
    },
    actions: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
